import { goToPosition, useGamePlay } from "../../redux/gamePlay";
import { FaFastBackward } from "react-icons/fa";
import { FaStepForward } from "react-icons/fa";
import { FaFastForward } from "react-icons/fa";
import { FaStepBackward } from "react-icons/fa";
import MoveButton from "@/components/ui/move-button";
import { Button } from "@/components/ui/button";

export default function MoveButtons() {
  const { moves, positionIndex } = useGamePlay();

  return (
    <div className="flex justify-center py-2 mx-5 space-x-2">
      <Button
        variant="ghost"
        disabled={positionIndex === 0}
        onClick={() => goToPosition(0)}
      >
        <FaFastBackward />
      </Button>
      <Button
        variant="ghost"
        disabled={positionIndex === 0}
        onClick={() => {
          if (positionIndex > 0) goToPosition(positionIndex - 1);
        }}
      >
        <FaStepBackward />
      </Button>
      <Button
        variant="ghost"
        disabled={positionIndex === moves.length}
        onClick={() => {
          if (positionIndex < moves.length) goToPosition(positionIndex + 1);
        }}
      >
        <FaStepForward />
      </Button>
      <Button
        variant="ghost"
        disabled={positionIndex === moves.length}
        onClick={() => goToPosition(moves.length)}
      >
        <FaFastForward />
      </Button>
    </div>
  );
}
